import { FC, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import DataTable from 'components/tables/data-table';
import { downloadBillableEventsWithSpecification, fetchBillableEventsWithSpecification } from 'services';
import { ActiveUnit, BillableEvent } from 'types';

import { billableEventDataColumns } from './billable-event-list.context';

type BillableEventsGridInputs = {
  unit: ActiveUnit | null;
  rowClicked: (billableEvent: BillableEvent) => void;
};

const BillableEventsList: FC<BillableEventsGridInputs> = ({ rowClicked }) => {
  const { unitId } = useParams();

  const fetchData = useMemo(() => fetchBillableEventsWithSpecification({ unitId }), [unitId]);

  return (
    <DataTable
      fetchData={fetchData}
      fetchCsv={downloadBillableEventsWithSpecification({ unitId })}
      columns={billableEventDataColumns}
      initialPage={{ pageNum: 0, pageSize: 100 }}
      onRowClick={(row: BillableEvent) => rowClicked(row)}
      initialColumns={['timestamp', 'type', 'label', 'unit', 'cost', 'operator'].map(c => {
        return { field: c, width: 80 };
      })}
    />
  );
};

export default BillableEventsList;
